module.exports = __webpack_public_path__ + "static/media/Melisandre 2.9f98c1b7.jpg";